import { path } from "ramda";
import ModalUtil, { findErrorMessage } from "../util/modal";
import OrganizationAction from "../reducers/OrganizationReducer";
import { ArrayUtil, isFillAlive, isAlive } from "../util/index";
import I18n from "../i18n";
import Store, { ReducerKeys } from "../reducers";
import InfoErrorStatus from "../constants/errorStatus";
import { BaseSupportGraph } from "../constants/supportGraph";

const DateRangeKey = {
	Start:"start",
	End:"end"
};
const CompareDateRangeKey = {
	PrimaryStart:"start0",
	PrimaryEnd:"end0",
	SecondaryStart:"start1",
	SecondaryEnd:"end1"
};

export function buildDatePayload(dateRange) {
	return ArrayUtil.isAliveArray(dateRange) ? {
		[DateRangeKey.Start]: dateRange[0].unix(), 
		[DateRangeKey.End]: dateRange[1].unix()
	} : {};
}
export function buildCompareDatePayload(primaryRange, secondaryRange){
	const out = {
		[CompareDateRangeKey.PrimaryStart]:null,
		[CompareDateRangeKey.PrimaryEnd]:null,
		[CompareDateRangeKey.SecondaryStart]:null,
		[CompareDateRangeKey.SecondaryEnd]:null
	};
	if(ArrayUtil.isAliveArray(primaryRange)){
		out[CompareDateRangeKey.PrimaryStart] = primaryRange[0].unix();
		out[CompareDateRangeKey.PrimaryEnd] = primaryRange[1].unix();
	}
	if(ArrayUtil.isAliveArray(secondaryRange)){
		out[CompareDateRangeKey.SecondaryStart] = secondaryRange[0].unix();
		out[CompareDateRangeKey.SecondaryEnd] = secondaryRange[1].unix();
	}
	return out;
}
export function getToken() {
	return path([ReducerKeys.AUTHEN, "token"], Store.getState());
}
export function getCorpId() {
	return path([ReducerKeys.ORGANIZATION, "orgID"], Store.getState());
}
/**
* Fetch handler.
* @param {function} caller 
* @param {array} dataPath 
* @param {object} payload 
* @param {function} resolve 
* @param {function} reject 
* @param {object} config
* @returns {Promise}
*/
export function fetchHandler(caller, dataPath = ["data"], payload, resolve, reject, errorOnInfo, configs) {
	const { 
		payloadName="payload",
		payloadMod = (packPayload)=>packPayload,
	} = configs || {};
	let headers = { token: getToken() };
	const organization = getCorpId();
	if(organization){
		headers = {...headers,  organization};
	}
	// console.log("headers: ",headers);
	try {
		const packPayload = payloadMod({ headers, [payloadName]:payload  });
		Store.dispatch(OrganizationAction.setOrganizationLoadingRequest());
		caller(packPayload).then((res) => {
			const data = ArrayUtil.isAliveArray(dataPath) ? path(dataPath, res) : res;
			if(res.ok && isAlive(data)) {
				Store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				resolve(data);
			} else {
				let printMessage = findErrorMessage(res);
				switch(res.status){
				case InfoErrorStatus.NOT_ENOUGH_DATA:
					if (errorOnInfo) {
						printMessage = ModalUtil.showErrorInfo({ title: I18n.t("not_enough_data_title"), resError: res });
					}
					break;
				case InfoErrorStatus.NOT_FOUND:
					ModalUtil.showCustomError({
						title:I18n.t("service_unavailable.title"),
						message:I18n.t("service_unavailable.message")
					});
					break;
				case InfoErrorStatus.SERVER_ERROR:
					if(process.env.NODE_ENV === "development"){
						if (!ModalUtil.showError(res, false)) {
							ModalUtil.showDefaultError();
						}
					}else{
						ModalUtil.showCustomError({
							title:I18n.t("server_error.title"),
							message:I18n.t("server_error.message")
						});
					}
					break;
				case 200:
					/**
					 * For whatever response, if data response as null or undefined with status 200,
					 * show not enough data.
					 */
					if (errorOnInfo) {
						printMessage = ModalUtil.showErrorInfo({ title: I18n.t("not_enough_data_title"), resError: res });
					}
					break;
				default:
					if (!ModalUtil.showError(res, false)) {
						ModalUtil.showDefaultError();
					}
					break;
				}
				Store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
				reject({message:printMessage, status:res.status});
			}
		});
	} catch (e) {
		console.error(e);
		ModalUtil.showDefaultError();
		Store.dispatch(OrganizationAction.setOrganizationLoadingFinish());
		reject(false);
	}
}

export function mergePayloadByFilter(payload, filters){
	if(!isFillAlive(filters)){
		return payload;
	}
	const formatKey = "%key";
	const format = `filters[${formatKey}]`;
	filters.forEach(({key,value})=>{
		if(key === BaseSupportGraph.AgeRange){
			payload[format.replace(formatKey, `${key}_start`)] = value[0];
			payload[format.replace(formatKey, `${key}_end`)] = value[1] || 200;
		}else{
			payload[format.replace(formatKey, key)] = value;
		}
	});
	return payload;
}


// WEBPACK FOOTER //
// ./src/util/actions.js